/**
 * Pagos CXP — pantalla unificada de pagos a suplidores.
 *
 * La vista principal es el mantenimiento de pagos embebido (ares8540:
 * pagos por fechas/suplidor, anular — revierte las facturas — y
 * reimprimir). La tarjeta "Pagar a suplidores" (ares8515) abre el
 * formulario de pago con distribución entre facturas en diálogo a
 * pantalla completa; al guardar, el listado se recarga.
 *
 * Sustituye las entradas de menú de pagoscxp.js y mantenimientopagoscxp.js.
 */
import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import { useMaterialUIController } from "context";
import { FP, PageHeader, ActionCard } from "components/financepro";
import { tienePermisosModulo } from "lib/seguridad/permisosPorModulo";
import PagosCxp from "modules/cuentasxpagar/pagoscxp";
import MantenimientoPagosCxp from "modules/cuentasxpagar/mantenimientopagoscxp";
import useAccionInicial from "lib/useAccionInicial";

export default function CxpPagos() {
  const [controller] = useMaterialUIController();
  const { roleDetalles } = controller;

  // Permisos por programa ARES (el backend re-valida en permisos.py).
  const puedePagar = tienePermisosModulo(roleDetalles, "ares8515");
  const puedeMantenimiento = tienePermisosModulo(roleDetalles, "ares8540");

  const [pagoOpen, setPagoOpen] = useState(false);

  // Enlace profundo desde el buscador global (?accion=...).
  useAccionInicial({
    pagar: { permitido: puedePagar, abrir: () => setPagoOpen(true) },
  });

  // Incrementarlo recarga el listado embebido (tras registrar un pago).
  const [refreshKey, setRefreshKey] = useState(0);
  const refrescar = () => setRefreshKey((k) => k + 1);

  return (
    <Box component="main" sx={{ minHeight: "100vh", bgcolor: FP.color.surface }}>
      <PageHeader
        title="Pagos a Suplidores"
        subtitle="Paga las facturas pendientes y gestiona los pagos aplicados en un solo lugar"
      />

      <Box sx={{ p: { xs: 2, md: 3 } }}>
        {puedePagar && (
          <Grid container spacing={2.5} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <ActionCard
                icon={PaymentsOutlinedIcon}
                titulo="Pagar a suplidores"
                descripcion="Aplica pagos a las facturas pendientes de un suplidor"
                color={FP.color.success}
                onClick={() => setPagoOpen(true)}
              />
            </Grid>
          </Grid>
        )}

        {/* Vista principal: mantenimiento de pagos (anular/reimprimir) */}
        {puedeMantenimiento && <MantenimientoPagosCxp embedded refreshToken={refreshKey} />}
      </Box>

      {/* Pagar a suplidores (formulario completo a pantalla completa) */}
      <Dialog fullScreen open={pagoOpen} onClose={() => setPagoOpen(false)}>
        <PagosCxp embedded onExit={() => { setPagoOpen(false); refrescar(); }} onSaved={refrescar} />
      </Dialog>
    </Box>
  );
}
